import Copy from '@/components/CopyToClipboard';
import React from 'react';
import { formatDate } from './formatDate';
import { transformWareHouse } from './transformWareHouse';

const transformMap = {
  warehouseCode: (value: string) => transformWareHouse(value),
  fromWarehouseCode: (value: string) => transformWareHouse(value),
  warehouse: (value: string) => transformWareHouse(value),
  toWarehouseCode: (value: string) => transformWareHouse(value),
  createTime: (value: string) => formatDate(value),
  beginTime: (value: string) => formatDate(value),
  endTime: (value: string) => formatDate(value),
  complteTime: (value: string) => formatDate(value),
  compeletTime: (value: string) => formatDate(value),
  completeTime: (value: string) => formatDate(value),
  operationTime: (value: string) => formatDate(value),
  updateTime: (value: string) => formatDate(value),
  operationStartTime: (value: string) => formatDate(value),
  approveTime: (value: string) => formatDate(value),
  operationEndTime: (value: string) => formatDate(value),
  createJobTime: (value: string) => formatDate(value),
  auditTime: (value: string) => formatDate(value),
  arriveTime: (value: string) => formatDate(value),
  unloadFinishTime: (value: string) => formatDate(value),
  receiveFinishTime: (value: string) => formatDate(value),
  putawayFinishTime: (value: string) => formatDate(value),
  startTime: (value: string) => formatDate(value),
  finishTime: (value: string) => formatDate(value),
  actualDate: (value: string) => formatDate(value),
  appointmentReceiveDate: (value: string) => formatDate(value),
  actualArriveDate: (value: string) => formatDate(value),
  planPutawayDate: (value: string) => formatDate(value),
  expiryDate: (value: string) => formatDate(value, 'YYYY-MM-DD'),
  expireDate: (value: string) => formatDate(value, 'YYYY-MM-DD'),
  receiveTime: (value: string) => formatDate(value),
  requestMsg: (value: string) => <Copy value={value} len={40} />,
  params: (value: string) => <Copy value={value} />,
  responseMsg: (value: string) => <Copy value={value} len={40} />,
  productCode: (value: string) => <Copy value={value} />,
  time: (value: string) => formatDate(value),
  synTime: (value: string) => formatDate(value),
  effectiveDate: (value: string) => formatDate(value),
  expectedOutboundTime: (value: string) => formatDate(value),
  finishWaveDateTime: (value: string) => formatDate(value),
  cancelOrInterceptSucTime: (value: string) => formatDate(value),
  starTime: (value: string) => formatDate(value),
  expectPutawayDate: (value: string) => formatDate(value),
  packCompleteTime: (value: string) => formatDate(value),
  exceptionTime: (value: string) => formatDate(value),
  dispatchCarCompleteTime: (value: string) => formatDate(value),
  dispatchCarBeginTime: (value: string) => formatDate(value),
};

export { transformMap };
